import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SidebarPropertyError({
  propertyLabel
}) {
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    marginBlockEnd: "200",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "cardProperties.sidebarPropertyError_jsx",
      options: {
        propertyLabel,
        href: window.location.href
      },
      elements: {
        Link
      }
    })
  });
}